module.exports = __webpack_public_path__ + "fonts/subset-MullerBold.ea94baf1.woff2";